<!-- CONTAINER -->
<div class="container content-area relative">

    <!-- PAGE-HEADER -->
    <div class="page-header">
        <h4 class="page-title">Issue</h4>
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
            <li class="breadcrumb-item"><a [routerLink]="['/admin/issue/customer']">Customer Issues</a></li>
            <li class="breadcrumb-item active" aria-current="page">Reply</li>
        </ol>
    </div>
    <!-- PAGE-HEADER END -->
    
    <!-- ROW-1 OPEN -->
    <div class="row" id="user-profile">
        <div class="col-lg-6">
            <div class="card-header bg-white">
                <h3 class="card-title">Reply</h3>
            </div>
            <div class="card">
                <div class="card-body">
                    <!-- <div class="user-wrap">
                        <button type="submit()" class="btn btn-primary mt-1 mb-2"><i class="fa fa-rss"></i> Add Skills</button>
                    </div> -->
                    <div>
                        <form [formGroup]="formGroup" (submit)="replyIssue()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="issueId">Issue ID</label>
                                        <input type="text" class="form-control " name="issueId"
                                            [value]="issueId" readonly>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="title">Title</label>
                                        <input type="text" class="form-control " name="title"
                                            [value]="title" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="reply">Description</label>
                                        <textarea class="form-control "
                                            name="description" readonly>{{description}}</textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="reply">Issue Status</label><br/>
                                        <input type="checkbox" name="issue_solved" (change)="isIssueSolved($event)"/>
                                        <label class="ml-2">Is Issue Solved?</label>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <label for="reply">Reply</label>
                                        <textarea class="form-control " name="reply_by_system"
                                            formControlName="reply_by_system" placeholder="Reply"></textarea>
                                        <div *ngIf="f.reply_by_system.invalid && (f.reply_by_system.dirty || f.reply_by_system.touched)"
                                            class="alert alert-danger mt-1">
                                            Required
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="user-wrap d-flex justify-content-center">
                                        <button type="submit()" class="btn-form-custom col-4 btn btn-success mt-1 mb-2"
                                            [disabled]="!formGroup.valid"> Submit</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div><!-- COL-END -->
        <div class="col-lg-6">
            <div class="card-header bg-white">
                <h3 class="card-title">Refund</h3>
            </div>
            <div class="card">
                <div class="card-body">
                    <!-- <div class="user-wrap">
                        <button type="submit()" class="btn btn-primary mt-1 mb-2"><i class="fa fa-rss"></i> Add Skills</button>
                    </div> -->
                    <div>
                        <form [formGroup]="refundGroup" (submit)="refundIssue()">
                            <div class="row">
                                <div class="col-md-12 mb-2">
                                    <p class="lead">Total Amount: {{data.amount | currency:'INR':'symbol-narrow'}}</p>
                                    <div class="alert alert-info">
                                        <label for="">Note:</label>
                                    <small>For <b>Full Refund</b> Max amount = {{data.amount | currency:'INR':'symbol-narrow'}} and for <b>Partial Refund</b> amount should be less than total amount.</small>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="reply">Refund Type</label>
                                        <select class="form-control" (change)="refundType($event)">
                                            <option selected>Wallet Recharge</option>
                                            <option>Assign Promo</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12" *ngIf="isAmountRefund">
                                    <div class="form-group">
                                        <label for="reply">Amount</label>
                                        <input type="text" class="form-control" name="amount_refunded"
                                            formControlName="amount_refunded" placeholder="Only Numbers Allowed">
                                        <div *ngIf="r.amount_refunded.invalid && (r.amount_refunded.dirty || r.amount_refunded.touched)"
                                            class="alert alert-danger mt-1">
                                            Required. Only Numbers Allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="isPromoRefund">
                                    <div class="form-group">
                                        <label for="reply">Duration (In Minutes)</label>
                                        <input type="text" class="form-control" name="duration"
                                            formControlName="duration" placeholder="Only Numbers Allowed">
                                        <div *ngIf="r.duration.invalid && (r.duration.dirty || r.duration.touched)"
                                            class="alert alert-danger mt-1">
                                            Required. Only Numbers Allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="isPromoRefund">
                                    <div class="form-group">
                                        <label for="">Promo Type</label>
                                        <select class="form-control" (change)="promoType($event)">
                                            <option value="" selected disabled>Select Type</option>
                                            <option value="call">Promo Call</option>
                                            <option value="chat">Promo Chat</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="isPromoRefund">
                                    <div class="form-group">
                                        <label for="">Astrologer</label>
                                        <select class="form-control" formControlName="astroId">
                                            <option value="" selected disabled>Select Astrologer</option>
                                            <option [value]="astro._id" *ngFor="let astro of astroList">{{astro.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="user-wrap d-flex justify-content-center">
                                        <button type="submit()" class="btn-form-custom col-4 btn btn-success mt-1 mb-2"
                                            [disabled]="!refundGroup.valid">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div><!-- COL-END -->
    </div>
    <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->
